import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { GraphModule } from '@app/graph-module/graph.module';
import { PatronsListPage } from '@app/patrons-routing/patrons-list-page/patrons-list-page.component';
import { SharedModule } from '@app/shared/shared.module';
import { PatronGraphPageComponent } from './patron-graph-page/patron-graph-page.component';
import { PatronGraphSidePanelComponent } from './patron-graph-side-panel/patron-graph-side-panel.component';

const patronRoutes: Routes = [
  {
    path: '',
    component: PatronsListPage,
  },
  {
    path: ':id/graph',
    component: PatronGraphPageComponent,
  },
];

@NgModule({
  declarations: [PatronsListPage, PatronGraphPageComponent, PatronGraphSidePanelComponent],
  imports: [RouterModule.forChild(patronRoutes), FormsModule, CommonModule, SharedModule, GraphModule],
  exports: [RouterModule, PatronsListPage, PatronGraphPageComponent, PatronGraphSidePanelComponent],
})
export class PatronsRoutingModule {}
